import React, { useState } from "react";
import PropTypes from "prop-types";
import JobDetails from "./JobDetail";
import responseTypes from "../../utils/responseTypes";

const MyCompletedJobs = ({ myCompletedJobs }) => {
  const [expandedJobs, setExpandedJobs] = useState(new Set());

  const toggleJob = (orderNumber) => {
    setExpandedJobs((prev) => {
      const next = new Set(prev);
      next.has(orderNumber) ? next.delete(orderNumber) : next.add(orderNumber);
      return next;
    });
  };

  const renderJobStatus = (status) => {
    switch (status) {
      case responseTypes().STATUS_COMPLETE:
        return "Completed";

      case responseTypes().STATUS_QA_PENDING:
        return "QA Pending";

      case responseTypes().STATUS_CHECKED:
        return "Checked";
    }
  };

  return (
    <div className="row">
      <div className="col-md-12">
        {myCompletedJobs.length === 0 ? (
          <p className="fw-bold">You have no jobs to display</p>
        ) : (
          myCompletedJobs.map((job) => {
            const isExpanded = expandedJobs.has(job.orderNumber);
            return (
              <div key={job.orderNumber} className="card mb-3">
                <div
                  className="card-header"
                  onClick={() => toggleJob(job.orderNumber)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <span style={{ fontSize: "0.9rem" }}>Ref: {job.orderNumber}</span>
                    <div className="d-flex align-items-center gap-2">
                      <span className="fw-bold" style={{ fontSize: "0.9rem" }}>
                        Job Value:{" "}
                        {new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(
                          job.engineerTotal
                        )}
                      </span>
                      <span style={{ fontSize: "0.8rem" }}>{isExpanded ? "▲" : "▼"}</span>
                    </div>
                  </div>
                  <div className="d-flex flex-wrap gap-2 mt-1">
                    <span className="fw-medium" style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
                      <span className="text-muted fw-normal">Name: </span>{job.name.firstName} {job.name.lastName}
                    </span>
                    <span style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
                      <span className="text-muted">Install Due: </span>
                      {new Intl.DateTimeFormat("en-GB", { day: "2-digit", month: "short", year: "numeric" }).format(
                        new Date(job.installDate)
                      )}
                    </span>
                    <span style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
                      <span className="text-muted">Date Installed: </span>
                      {new Intl.DateTimeFormat("en-GB", { day: "2-digit", month: "short", year: "numeric" }).format(
                        new Date(job.completionDetail.installationCompletionDate)
                      )}
                    </span>
                    <span style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
                      <span className="text-muted">Status: </span>
                      {renderJobStatus(job.orderStatus)}
                    </span>
                  </div>
                </div>
                {isExpanded && (
                  <>
                    <JobDetails job={job} options={{ showPersonalInfo: true }} />
                    <div className="card-footer">
                      <div className="row">
                        <div className="col-xs-12 col-md-6">
                          <p>
                            <span className="text-muted">Date Submitted for QA:</span>{" "}
                            {new Intl.DateTimeFormat("en-GB", {
                              year: "numeric",
                              month: "long",
                              day: "2-digit",
                              hour: "2-digit",
                              minute: "2-digit",
                            }).format(new Date(job.completionDetail.dateSubmittedForQA))}
                          </p>
                          <p className="">
                            <span className="text-muted">QA Check Date:</span>{" "}
                            {job.completionDetail.qaCheckDate
                              ? new Intl.DateTimeFormat("en-GB", { year: "numeric", month: "long", day: "2-digit" }).format(
                                  new Date(job.completionDetail.qaCheckDate)
                                )
                              : "Awaiting QA"}
                          </p>
                          <p>
                            <span className="text-muted">QA Passed:</span>{" "}
                            {job.completionDetail.qaPassed
                              ? "Yes"
                              : job.completionDetail.qaPassed === false
                              ? "No"
                              : "Awaiting QA"}
                          </p>
                        </div>
                        <div className="col-xs-12 col-md-6">
                          <small
                            className="text-muted text-uppercase fw-semibold"
                            style={{ fontSize: "0.75rem", letterSpacing: "0.05em" }}
                          >
                            QA Comments
                          </small>
                          <p className="mt-1" style={{ whiteSpace: "pre-wrap" }}>
                            {job.completionDetail.qaComments || <span className="text-muted fst-italic">No comments</span>}
                          </p>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

MyCompletedJobs.propTypes = {
  myCompletedJobs: PropTypes.array.isRequired,
};

export default MyCompletedJobs;
